import comp from "./TextWithAvatar";
export default comp;
